module.exports = __webpack_public_path__ + "img/socialMediaTwitterGreen.fcffdfdf.png";